import { Modal } from 'react-bootstrap';
import EmbeddedNavigationView from 'components/navigation/EmbeddedNavigationView';

// Mobile renders inside the Page Actions dialog; desktop keeps a centered modal.
export default function ParticipationModal({ embedded, show, onHide, title, icon, footer, children }) {
  if (embedded) {
    return (
      <EmbeddedNavigationView parent="participation" show={show} title={title} onClose={onHide}>
        <div className="mobile-tool-body participation-form">{children}</div>
        <div className="mobile-tool-footer d-flex flex-wrap align-items-center justify-content-end gap-2 mt-3">{footer}</div>
      </EmbeddedNavigationView>
    );
  }
  return (
    <Modal show={show} onHide={onHide} centered backdrop="static" className="text-center modal-md" data-bs-theme={'dark'}>
      <Modal.Header closeButton>
        <Modal.Title className="d-flex align-items-center gap-2">
          <i className={`bi ${icon}`}></i>
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer>{footer}</Modal.Footer>
    </Modal>
  );
}
